"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FerryPaymentHistoryRecord {
}
exports.default = FerryPaymentHistoryRecord;
//# sourceMappingURL=FerryPaymentHistoryRecord.js.map